import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import DashboardToday from './DashboardToday.js';
import { actions } from './DashboardToday.actions';
import {
    mainSelector
} from './DashboardToday.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    data: mainSelector
});

const DashboardTodayComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state)
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getData: actions.getData
        };
    }
)(DashboardToday);

export default DashboardTodayComponent;
